export function getEnvString(key: string) {
  const value = process.env[key]

  if (!value) {
    throw new Error(`The environment variable ${key} cannot be undefined`)
  }

  return value
}

export function getEnvBoolean(key: string, defaultValue?: boolean) {
  const value = process.env[key]

  if (!value && defaultValue === undefined) {
    throw new Error(`The environment variable ${key} cannot be undefined`)
  }

  return value !== undefined ? value.toLowerCase() === 'true' : defaultValue
}

export function getEnvArray(key: string, defaultValue?: string[]) {
  const value = process.env[key]

  if (!value && defaultValue === undefined) {
    throw new Error(`The environment variable ${key} cannot be undefined`)
  }

  return value ? value.split(',') : defaultValue
}
